<!-- eslint-disable max-len -->
<template>
  <div class="ac-create-order ac-card-content">
    <div class="ac-header-container">
      <button type="button" class="ac-close-button" @click="toggleActionModal(false)">
        <img src="@shared/assets/img/general/x-black.png" alt="x" class="ac-close" />
      </button>
      <div class="ac-header">Import CSV</div>
    </div>
    <div
      v-if="Object.keys(errorObj).length > 0 && techs.filter((obj) => obj.notInvite).length === 0"
      class="error-container"
    >
      <span>{{ Object.keys(errorObj).length }} Errors Stopped Items from Importing. &nbsp;</span>
      <span>Please fix errors below and import .CSV again.</span>
    </div>
    <div
      v-else-if="showInvite && techs.filter((obj) => obj.notInvite).length > 0"
      class="invite-container"
    >
      {{
        techs.filter((obj) => obj.notInvite).length > 1
          ? ` ${techs.filter((obj) => obj.notInvite).length} Items will not
      be Imported.`
          : ` ${techs.filter((obj) => obj.notInvite).length} Item will not be Imported.`
      }}
    </div>
    <div class="ac-body-container">
      <div class="table-container">
        <span>First Name</span>
        <span>Last Name</span>
        <span>Email</span>
        <span>Phone</span>
        <span v-if="showPassword">Password</span>
        <span v-if="Object.keys(errorObj).length > 0">Do not invite</span>
      </div>
      <div v-for="(s, idx) in techs" :key="idx" class="order-row-container">
        <div class="o-flex-container flex-column">
          <div class="flex-column margin-top-4">
            <div class="table-container">
              <div class="tb-item">
                <SACInput
                  :id="`firstName-${idx}`"
                  type="text"
                  field="firstName"
                  :value="s.firstName"
                  :error="errorObj[`firstName-${idx}`]"
                  :change="(f, v) => changeTechInfo(f, v, idx)"
                  :isV2="true"
                  :showError="s.notInvite"
                />
              </div>
              <div class="tb-item">
                <SACInput
                  :id="`lastName-${idx}`"
                  type="text"
                  field="lastName"
                  :value="s.lastName"
                  :error="errorObj[`lastName-${idx}`]"
                  :change="(f, v) => changeTechInfo(f, v, idx)"
                  :isV2="true"
                  :showError="s.notInvite"
                />
              </div>
              <div class="tb-item">
                <SACInput
                  :id="`email-${idx}`"
                  type="text"
                  field="email"
                  :value="s.email"
                  :error="errorObj[`email-${idx}`]"
                  :change="(f, v) => changeTechInfo(f, v, idx)"
                  :isV2="true"
                  :showError="s.notInvite"
                />
              </div>
              <div class="tb-item">
                <SACInput
                  :id="`phone-${idx}`"
                  type="number"
                  field="phone"
                  restrict="phone-number"
                  :value="s.phone"
                  :error="errorObj[`phone-${idx}`]"
                  :change="(f, v) => changeTechInfo(f, v, idx)"
                  :isV2="true"
                  :showError="s.notInvite"
                />
              </div>
              <div v-if="showPassword" class="tb-item">
                <SACInput
                  :id="`password-${idx}`"
                  type="text"
                  field="password"
                  :value="s.password"
                  :change="(f, v) => changeTechInfo(f, v, idx)"
                  :isV2="true"
                  :showError="s.notInvite"
                />
              </div>
              <div v-if="Object.keys(errorObj).length > 0 || showInvite" class="tb-item">
                <div class="tb-sub-item">
                  <SACCheckbox :checked="s.notInvite" :change="() => changeTechInvite(idx)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="info-item">Does the imported information look correct?</p>
      <button
        type="button"
        class="reupload-button"
        @click="toggleActionModal(true, 'bulk-tech', {})"
      >
        Re-Upload
      </button>
    </div>
    <div class="ac-footer-container">
      <button type="button" class="f-button" @click="toggleActionModal(false)">Cancel</button>
      <button type="button" class="f-button blue" :disabled="invite" @click="createBatchTechs">
        Invite All
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>

<script>
import technicianMixin from '@shared/mixins/technicianMixin';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import formatPhoneNumber from '@shared/lib/formatter/formatPhoneNumber';

export default {
  name: 'CreateTech',
  components: {
    SACInput,
    SACCheckbox,
    ProcessOverlay,
  },
  mixins: [technicianMixin],
  data() {
    return {
      techs: [],
      showInvite: false,
      processing: false,
      invite: false,
    };
  },
  computed: {
    showPassword() {
      let show = false;
      this.techs.forEach((tech) => {
        if (tech.password) {
          show = true;
        }
      });
      return show;
    },
  },
  mounted() {
    if (this.newTechsUpload.length > 0) {
      const techsMapped = this.newTechsUpload.map((p) => ({
        ...p,
        notInvite: false,
        phone: formatPhoneNumber(p.phone),
      }));
      this.techs = techsMapped;
    }
  },
  methods: {
    async createBatchTechs() {
      try {
        const techMapped = this.techs.filter((obj) => !obj.notInvite);
        if (techMapped.length > 0) {
          this.invite = false;
          this.processing = true;
          const res = await this.$store.dispatch('batchTech', {
            technicianList: techMapped,
          });
          if (res) {
            await this.$store.dispatch('getTechnicianList');
          }
          if (Object.keys(this.errorObj).length === 0) {
            this.toggleActionModal(false);
          }
        } else {
          this.invite = true;
        }
      } catch (err) {
        console.error(err);
      }
      this.processing = false;
    },
    changeTechInfo(field, value, idx) {
      if (field === 'phone') {
        value = formatPhoneNumber(value);
      }
      const nTech = this.techs.slice();
      nTech[idx] = {
        ...nTech[idx],
        [field]: value,
      };
      this.techs = nTech;
    },
    changeTechInvite(idx) {
      const nTech = this.techs.slice();
      nTech[idx].notInvite = !nTech[idx].notInvite;
      this.techs = nTech;
      this.showInvite = true;
      const techMapped = this.techs.filter((obj) => !obj.notInvite);
      this.invite = !(techMapped.length > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr auto;
}

.tb-sub-item {
  padding-left: 50px;
  padding-top: 10px;
}

.error-container {
  align-items: flex-start;
  background-color: #fbd6d4;
  display: flex;
  height: 37px;
  padding: 9px 25px;
  margin-bottom: 13px;

  span {
    color: rgba(43, 55, 87, 1);
    font-weight: 400;
  }

  span:nth-of-type(1) {
    color: rgba(43, 55, 87, 1);
    font-weight: bold;
  }
}

.invite-container {
  align-items: flex-start;
  background-color: #becdf7;
  display: flex;
  height: 37px;
  padding: 9px 25px;
  margin-bottom: 13px;
  color: rgba(43, 55, 87, 1);
  font-weight: bold;
}

.info-item {
  color: black;
  height: 23px;
  padding: 30px 0px;
}

.reupload-button {
  color: rgba(73, 121, 255, 1);
  font-weight: 500;
  height: 23px;
  text-decoration: underline;
  padding: 0px 0px 50px 0px;
  width: 100px;
  cursor: pointer;
}

.ac-footer-container {
  display: flex;
  justify-content: flex-start;

  .f-button {
    background-color: $N50;
    border-radius: 8px;
    color: white;
    padding: 12px 18px;
    font-weight: 500;

    &.blue {
      background-color: $NBLUE100;
    }

    &:disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
